export function debouncePerRow<T extends { [key: string]: any }>(
  func: (data: T) => Promise<void> | void,
  wait: number = 1000,
  idKey: keyof T = 'id'
) {
  const timeouts = new Map<any, NodeJS.Timeout>();

  return (data: T) => {
    const rowId = data[idKey];

    if (timeouts.has(rowId)) {
      clearTimeout(timeouts.get(rowId));
    }

    const timeout = setTimeout(() => {
      func(data);
      timeouts.delete(rowId);
    }, wait);

    timeouts.set(rowId, timeout);
  };
}

export const debounceTimeout = 1000;